// src/Chatmodules/ingredientsList.js
const ingredientsList = [
    "arroz",
    "pasta",
    "avena",
    "quinoa",
    "trigo bulgur",
    "amaranto",
    "mijo",
    "espelta",
    "teff",
    "farro",
    "cous cous",
    "frijoles negros",
    "frijoles pintos",
    "garbanzos",
    "lentejas",
    "habas",
    "alubias blancas",
    "chicharos",
    "cebolla",
    "tomate",
    "zanahoria",
    "pimiento",
    "papa",
    "batata", // mejora
    "boniato",
    "lechuga",
    "espinaca",
    "col rizada",
    "rúcula",
    "brócoli",
    "coliflor",
    "col",
    "remolacha",
    "nabo",
    "jengibre",
    "calabacín",
    "berenjena",
    "pepino",
    "champiñones",
    "portobello",  // mejora
    "setas",
    "tofu",  // mejora
    "tempeh",  // mejora
    "naranja",
    "limón",
    "pomelo",
    "lima",
    "piña",
    "mango",
    "plátano",
    "papaya",
    "fresa",
    "frambuesa",
    "mora",
    "arándano",
    "manzana",
    "pera",
    "uva",
    "melón",
    "sandía",
    "kiwi",  // mejora
    "cereza",  // mejora
    "res",
    "ternera",
    "cerdo",
    "pollo",
    "pavo",
    "cordero",
    "cabra",
    "conejo",
    "salmón",
    "atún",
    "bacalao",
    "merluza",
    "trucha",
    "sardina",  // mejora
    "camarones",
    "langostinos",
    "mejillones",
    "almejas",
    "calamares",
    "sepia", // mejora
    "leche de vaca",
    "leche de cabra",
    "leche de soja",
    "leche de almendras",
    "leche de avena", // mejora
    "cheddar",
    "mozzarella",
    "parmesano",
    "feta",
    "brie",
    "yogurt natural",
    "yogurt griego",
    "yogurt bebible",
    "crema",
    "mantequilla",
    "nata",
    "huevo",
    "aceite de oliva",
    "aceite de girasol",
    "aceite de canola",
    "aceite de aguacate",
    "mantequilla",
    "ghee",
    "sal",
    "pimienta",
    "ajo",
    "cebolla en polvo",
    "comino",
    "cilantro",
    "curry",
    "paprika",
    "jengibre en polvo",
    "orégano",
    "albahaca",
    "perejil",
    "romero",
    "harina de trigo",
    "harina de avena",
    "harina de arroz",
    "harina de maíz",
    "azúcar blanco",
    "azúcar moreno",
    "panela",
    "miel", // mejora
    "jarabe de arce", // mejora
    "levadura seca",
    "levadura fresca",
    "vinagre balsámico",
    "vinagre de vino",
    "vinagre de manzana",
    "salsa de soja",
    "salsa Worcestershire",
    "salsa Tabasco",
    "almendras",
    "nueces",
    "semillas de chía",
    "semillas de lino",
    "anacardos", // mejora
    "pistachos", // mejora

    // Granos y cereales
    "arroz", "pasta", "avena", "quinoa", "trigo bulgur", "amaranto", "mijo", "espelta", "teff", "farro", "cous cous",
    "arroz integral", "arroz salvaje", "polenta",

    // Legumbres
    "frijoles negros", "frijoles pintos", "garbanzos", "lentejas", "habas", "alubias blancas", "chícharos",
    "edamame", "frijoles mung", "guandules",

    // Verduras
    "cebolla", "tomate", "zanahoria", "pimiento", "papa", "batata", "boniato", "lechuga", "espinaca", "col rizada",
    "rúcula", "brócoli", "coliflor", "col", "remolacha", "nabo", "jengibre", "calabacín", "berenjena", "pepino",
    "champiñones", "portobello", "setas", "tofu", "tempeh", "acelga", "bok choy", "alcachofa", "rábano", "lampo",

    // Frutas
    "naranja", "limón", "pomelo", "lima", "piña", "mango", "plátano", "papaya", "fresa", "frambuesa", "mora",
    "arándano", "manzana", "pera", "uva", "melón", "sandía", "kiwi", "cereza", "ciruela", "granada",

    // Carnes
    "res", "ternera", "cerdo", "pollo", "pavo", "cordero", "cabra", "conejo", "pato", "faisán", "codorniz", // Aves y caza

    // Pescados y mariscos
    "salmón", "atún", "bacalao", "merluza", "trucha", "sardina", "camarones", "langostinos", "mejillones", 
    "almejas", "calamares", "sepia", "ostras", "pulpo",

    // Productos lácteos y alternativos
    "leche de vaca", "leche de cabra", "leche de soja", "leche de almendras", "leche de avena", 
    "cheddar", "mozzarella", "parmesano", "feta", "brie", "yogurt natural", "yogurt griego", "yogurt bebible", 
    "crema", "nata", "mantequilla", "ghee",

    // Otros
    "huevo", "aceite de oliva", "aceite de girasol", "aceite de canola", "aceite de aguacate", "sal", "pimienta", 
    "ajo", "cebolla en polvo", "comino", "cilantro", "curry", "paprika", "jengibre en polvo", "orégano", 
    "albahaca", "perejil", "romero", "harina de trigo", "harina de avena", "harina de arroz", "harina de maíz", 
    "azúcar blanco", "azúcar moreno", "panela", "miel", "jarabe de arce", "levadura seca", "levadura fresca", 
    "vinagre balsámico", "vinagre de vino", "vinagre de manzana", "salsa de soja", "salsa Worcestershire", 
    "salsa Tabasco", "almendras", "nueces", "semillas de chía", "semillas de lino", "anacardos", "pistachos",

    // Ingredientes de caza
    "perdiz", "corzo", "gamo", "zorzal", "pato salvaje", "conejo", "casquería", "faisán", "ciervo", "pichón",

    // Otros productos
    "sirope de agave", "azúcar de coco", "manteca de cacao", "extracto de vainilla", "pasta de curry", "salsa de tomate",
];

export default ingredientsList;